const originalWebSocket = window.WebSocket;
window.WebSocket = function(url, ...args) {
  console.log('WebSocket connection intercepted:', url);
  if (url.startsWith('ws:')) {
    url = url.replace('ws:', 'wss:');
    console.log('Upgraded to WSS:', url);
  }
  return new originalWebSocket(url, ...args);
};

// Fix DWV worker URLs: DWV resolves workers relative to document.baseURI (page URL),
// but workers live at /static/js/assets/workers/ (absolute from app root).
const _OrigWorker = window.Worker;
window.Worker = function(scriptURL, options) {
  if (scriptURL instanceof URL && scriptURL.pathname.includes('/assets/workers/')) {
    const filename = scriptURL.pathname.split('/').pop();
    scriptURL = new URL('/static/js/assets/workers/' + filename, window.location.origin);
  }
  return new _OrigWorker(scriptURL, options);
};
window.Worker.prototype = _OrigWorker.prototype;